import { useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import _debounce from 'lodash/debounce';

import WatchClickOutside from '../WatchClickOutside';

import css from '@styles/catalogFilters';

function FilterSection({
  children,
  className,
  onClickOutside,
  enableClickOutside
}) {
  const sectionRef = useRef();

  return (
    <WatchClickOutside
      onClickOutside={onClickOutside}
      enabled={enableClickOutside}
      elRef={sectionRef}
      className={classnames(css.section, className)}
    >
      <section ref={sectionRef}>{children}</section>
    </WatchClickOutside>
  );
}

export default FilterSection;
